<template>

  <form class="modal-content form-horizontal fv-form fv-form-bootstrap4 orbinet-modal-form" v-if="languages.length">
    <div class="modal-header">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <button
        @click="submit"
        class="btn btn-icon btn-success"
        v-bind:class="{'btn-success': (!errors.email && !errors.password && isEdit) || (email && password && languageId && !isEdit && !errors.email && !errors.password ) || (withVerification && email && !errors.email)}"
        type="button">
        <i class="icon wb-check"></i>
      </button>
      <h4 v-if="isEdit" class="modal-title">{{ fullName }}</h4>
      <h4 v-if="!isEdit" class="modal-title">{{ t('menNewUser') }}</h4>
    </div>
    <div class="modal-body">

      <br v-if="withVerificationShow">

      <div class="row" v-if="withVerificationShow">
        <div class="col-md-7">
          <div class="checkbox-custom checkbox-primary">
            <input
              v-model="withVerification"
              type="checkbox"
              :id="modalHtmlId + 'verification'">
            <label :for="modalHtmlId + 'verification'">Registrace s ověřením e-mailové adresy</label>
          </div>
        </div>
      </div>

      <br>

      <div class="row" v-if="!withVerification">
        <div class="col-sm-6">
          <div class="form-group form-material floating" data-plugin="formMaterial">
            <input type="text"
                   v-model="firstName"
                   v-bind:class="{'empty': !firstName}"
                   @keyup.enter="submit"
                   name="firstName"
                   class="form-control"/>
            <label class="floating-label">Jméno</label>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group form-material floating" data-plugin="formMaterial">
            <input type="text"
                   v-model="lastName"
                   v-bind:class="{'empty': !lastName}"
                   @keyup.enter="submit"
                   name="lastName"
                   class="form-control"/>
            <label class="floating-label">Příjmení</label>
          </div>
        </div>
      </div>

      <div class="row">

        <div class="col-sm-6">
          <div v-bind:class="{'has-success': !errors.email && email, 'has-danger': errors.email}" class="form-group form-material floating"
               data-plugin="formMaterial">
            <input type="text"
                   v-model="email"
                   v-bind:class="{'empty': !email}"
                   @keyup="emailKeyup"
                   @keyup.enter="submit"
                   name="email"
                   class="form-control"/>
            <label class="floating-label">E-mail</label>
            <small v-if="errors.email" class="invalid-feedback">{{ errors.email }}</small>
          </div>
        </div>

        <div class="col-sm-6" v-if="!withVerification">
          <div class="form-group form-material floating" data-plugin="formMaterial">
            <input type="text"
                   v-model="mobilePhone"
                   v-bind:class="{'empty': !mobilePhone}"
                   @keyup.enter="submit"
                   name="mobilePhone"
                   class="form-control"/>
            <label class="floating-label">Mobilní telefon</label>
          </div>
        </div>
      </div>

      <div class="row" v-if="!withVerification">
        <div class="col-sm-6">
          <div v-bind:class="{'has-success': !errors.password && password, 'has-danger': errors.password}"
               class="form-group form-material floating" data-plugin="formMaterial">
            <input type="password"
                   v-model="password"
                   v-bind:class="{'empty': !password}"
                   @keyup="passwordKeyup"
                   @keyup.enter="submit"
                   name="password"
                   class="form-control"/>
            <label class="floating-label">Heslo</label>
            <small v-if="errors.password" class="invalid-feedback">{{ errors.password }}</small>
          </div>
        </div>
        <div class="col-sm-6">
          <div v-bind:class="{'has-success': !errors.passwordVerify && passwordVerify, 'has-danger': errors.passwordVerify}"
               class="form-group form-material floating" data-plugin="formMaterial">
            <input type="password"
                   v-model="passwordVerify"
                   v-bind:class="{'empty': !passwordVerify}"
                   @keyup="passwordKeyup"
                   @keyup.enter="submit"
                   name="passwordVerify"
                   class="form-control"/>
            <label class="floating-label">Ověření hesla</label>
            <small v-if="errors.passwordVerify" class="invalid-feedback">{{ errors.passwordVerify }}</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6">
          <div v-bind:class="{'has-success': !errors.languageId && languageId}" class="form-group row">
            <label class="col-xxl-3 form-control-label">Jazyk</label>
            <div class="col-xxl-9">
              <select
                type="languageId"
                v-model="languageId"
                v-bind:class="{'is-valid': !errors.languageId, 'is-invalid': errors.languageId || !languageId}"
                @keyup.enter="submit"
                name="languageId"
                class="form-control"
                placeholder="Jazyk">
                <option v-for="item in languages " :value="item.id">{{ item.Name }}</option>
              </select>
              <small v-if="errors.languageId" class="invalid-feedback">{{ errors.languageId }}</small>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>

</template>

<script>
import { validator } from '@/validator'

export default {
  name:    'user-form',
  props:   {
    defaultUser: {},
    editable:    {},
    modalHtmlId: {},
    fullName:    {}
  },
  data () {
    return {
      firstName:         '',
      lastName:          '',
      email:             '',
      password:          '',
      passwordVerify:    '',
      mobilePhone:       '',
      languageId:        1,
      defaultLanguageId: 1,

      errors: {
        email:          null,
        password:       null,
        passwordVerify: null,
        languageId:     null
      },

      isEdit:               false,
      withVerification:     true,
      withVerificationShow: true,
      emailTimer:           null,
      languages:            this.$store.getters.languages
    }
  },
  methods: {
    emailKeyup () {

      let error = null
      let email = this.email

      // overeni validniho emailu
      if (!validator.isEmail(email)) {
        this.errors.email = 'E-mail není validní'
        return
      }

      // verifikace emailu na strane API
      clearTimeout(this.emailTimer)
      this.emailTimer = setTimeout(function () {

        if (!validator.verifyEmail(email)) {
          error = 'E-mail není možné použít'
        }

      }, 500)

      this.errors.email = error

    },
    passwordKeyup () {
      if (this.passwordVerify !== this.password) {
        this.errors.passwordVerify = 'Hesla nejsou shodná'
        this.errors.password       = 'Hesla nejsou shodná'
      }
      else {
        this.errors.passwordVerify = null
        this.errors.password       = null
      }
    },
    submit (event) {
      event.preventDefault()

      if (this.withVerification) {
        this.verificationSubmit()
      }
      else {
        this.fullSubmit()
      }

    },
    verificationSubmit () {

      this.resetErrors()

      if (this.hasErrorsVerificationSubmit()) {
        return
      }

      let data = {
        Email:       this.email,
        IDtLanguage: this.languageId
      }

      this.$emit('verificationSubmit', data)
    },
    fullSubmit () {
      // validace
      this.resetErrors()

      if (this.hasErrorsFullSubmit()) {
        return
      }

      /* odeslani pozadavku */
      let data = {
        id:          this.defaultData ? this.defaultData.id : undefined,
        FirstName:   this.firstName,
        LastName:    this.lastName,
        Email:       this.email,
        MobilePhone: this.mobilePhone,
        Password:    this.password,
        IDtLanguage: this.languageId
      }

      this.$emit('submit', data)

      if (this.isEdit) {
        this.$emit('setFullName', {
          FirstName: data.FirstName,
          LastName:  data.LastName
        })
      }
      else {
        this.firstName   = ''
        this.lastName    = ''
        this.email       = ''
        this.mobilePhone = ''
        this.password    = ''
        this.languageId  = null
      }
    },
    hasErrorsFullSubmit () {
      let hasError = false

      if (!this.email) {
        hasError          = true
        this.errors.email = 'Prosím zadejte email'
      }

      if (!this.password && !this.isEdit) {
        hasError             = true
        this.errors.password = 'Prosím zadejte heslo'
      }

      if (!this.languageId) {
        hasError               = true
        this.errors.languageId = 'Prosím zvolte jazyk'
      }

      if (this.password !== this.passwordVerify) {
        hasError                   = true
        this.errors.password       = 'Hesla nejsou shodná'
        this.errors.passwordVerify = 'Hesla nejsou shodná'
      }

      return hasError
    },
    hasErrorsVerificationSubmit () {
      let hasError = false

      if (!this.email) {
        hasError          = true
        this.errors.email = 'Prosím zadejte email'
      }

      if (!this.languageId) {
        hasError               = true
        this.errors.languageId = 'Prosím zvolte jazyk'
      }

      return hasError
    },
    resetErrors () {
      this.errors = {
        email:          null,
        password:       null,
        passwordVerify: null,
        languageId:     null
      }
    },
    resetForm (user) {
      this.resetErrors()

      this.firstName      = user ? user.FirstName : ''
      this.lastName       = user ? user.LastName : ''
      this.email          = user ? user.Email : ''
      this.password       = ''
      this.passwordVerify = ''
      this.mobilePhone    = user ? user.MobilePhone : ''
      this.languageId     = user ? user.IDtLanguage : this.defaultLanguageId
    },
    setDefaults (user) {
      this.defaultData          = user
      this.isEdit               = true
      this.withVerification     = false
      this.withVerificationShow = false

      this.resetForm(user)
    }
  }
}
</script>

<style scoped>

</style>
